<template>
  <router-link
    class="commenterImage"
    :to="'/Activity/'+activity.id_curso"
    tag="div"
    style="cursor:pointer"
  >
    <div class="card card-curso" style="cursor: pointer; height:fit-content">
      <div>
        <h5 style="text-align:center; margin: 5px 10px">{{activity.nombre_curso}}</h5>
        <p class="card-text">{{activity.detalle_curso}}</p>
      </div>

      <vue-load-image>
        <img class="img-curso" slot="image" :src="activity.url_imagen" />
        <img class="img-curso" slot="preloader" src="public/images/site/loading.gif" />
        <div slot="error">No encontramos la imagen :-(</div>
      </vue-load-image>
    </div>
  </router-link>
</template>


<script>
import { mapGetters } from "vuex";
import VueLoadImage from "vue-load-image";

export default {
  props: ["activity"],
  data() {
    return {
      eliminaCategoria: "",
      errorMessage: ""
    };
  },
  computed: {
    ...mapGetters(["categorias", "userLogged", "pathAPI"])
  },
  methods: {
    accederCurso(curso) {
      if (this.userLogged.profile == "HIJO") {
        sessionStorage.cursoSeleccionado = curso.id_curso;
        this.$store.state.cursoSeleccionado = curso.id_curso;
        this.$router.push({ path: "/Activity" });
      }
    },
    cargarImagen() {
      this.loaded = true;
    }
  },
  components: {
    "vue-load-image": VueLoadImage
  }
};
</script>

<style scoped>
.img-curso {
  width: 250px;
  border-radius: 15px;
}
.card-curso {
  border-radius: 15px !important;
  border: 0px !important;
  width: 250px;
  align-items: center;
  transition: 0.2s;
  z-index: 0;
  margin: 10px;
}

.card-curso:hover {
  box-shadow: -1px 11px 16px 1px rgba(0, 0, 0, 0.32);
  transition: 0.2s;
  transform: scaleX(1.05) scaleY(1.05);
  z-index: 1;
}

@media screen and (max-width: 600px) {
  .card-curso {
    width: 140px;
    margin: 10px;
  }
  .img-curso {
    width: 140px;
    border-radius: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activities/Activity.vue